import debug from 'debug'
import posthog from 'posthog-js'

import config from '~/config'

const APP_ORIGIN = new URL(import.meta.url).origin
const log = debug('quantistry:posthog')

export function usePostHog() {
  function init() {
    const apiHost = `${APP_ORIGIN}/api/events`
    posthog.init(config.posthogAPIKey, {
      api_host: apiHost,
      ui_host: 'https://eu.posthog.com',
      capture_pageview: false,
      autocapture: false,
      person_profiles: 'identified_only',
      before_send: (result) => {
        if (result) {
          log(result.event, result)
        }

        // don't send events from local environments
        if (config.isDev) {
          return null
        }

        return result
      },
    })
    log('initialized', apiHost)
  }

  type A = Parameters<typeof posthog.capture>
  function captureFn<T extends (...args: any[]) => any>(fn: T, ...captureParams: A): ReturnType<T> {
    posthog.capture(...captureParams)
    return fn()
  }

  return {
    posthog,
    init,
    captureFn,
  }
}
